import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=4a15bdb5&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
import style0 from "./Help.vue?vue&type=style&index=0&id=4a15bdb5&prod&scoped=true&lang=css"
import style1 from "./Help.vue?vue&type=style&index=1&id=4a15bdb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15bdb5",
  null
  
)

export default component.exports